export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M11 21H2v-3h9v3Zm11 0h-9V3h9v18Zm-7.5-1.5h6v-15h-6v15ZM11 16H2v-3h9v3Zm0-5H2V8h9v3Zm0-5H2V3h9v3Z"/>
</svg>
`;
